import React from 'react';
import Icon from '../../../components/AppIcon';

const AgentCapabilities = ({ agent }) => {
  if (!agent) {
    return (
      <div className="p-6 bg-card border border-border rounded-xl">
        <div className="text-center text-muted-foreground">
          <Icon name="Info" size={32} className="mx-auto mb-2 opacity-50" />
          <p className="text-sm">Select an agent to view capabilities</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-card border border-border rounded-xl space-y-4">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name={agent?.icon} size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">{agent?.name}</h3>
          <p className="text-sm text-muted-foreground">{agent?.description}</p>
        </div>
      </div>
      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-foreground flex items-center gap-2">
          <Icon name="Sparkles" size={16} />
          Key Capabilities
        </h4>
        <div className="space-y-2">
          {agent?.capabilities?.map((capability, index) => (
            <div key={index} className="flex items-start gap-3 p-3 bg-muted/30 rounded-lg">
              <Icon name="CheckCircle2" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
              <p className="text-sm text-foreground leading-relaxed">{capability}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Response Time:</span>
          <span className="font-medium text-foreground">{agent?.responseTime}</span>
        </div>
      </div>
    </div>
  );
};

export default AgentCapabilities;